import { render, staticRenderFns } from "./redirections-suggestions.vue?vue&type=template&id=e9ecf088&"
import script from "./redirections-suggestions.vue?vue&type=script&lang=ts&"
export * from "./redirections-suggestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports